import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { Button } from "@/components/ui/button";
import { backofficeLinks, onlineOrderingLinks } from "@/components/lib/SidebarLinks";
import { useState, useMemo, useEffect } from "react";
import { Form } from "@/components/ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import useAuth from "@/hooks/useAuth";
import { getFirstErrorMessage } from "@/lib/utils";
import { toast } from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation, useParams, Link } from "react-router-dom";
import { setItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";
import FormInputField from "@/components/lib/from-input-field";
import FileUploader from "@/components/common/file-uploader";
import useUploaderConfig from "@/hooks/useUploaderConfig";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { clearNoticeMessages, createNewNotice, updateExistingNotice } from "@/redux/slice/order-ordering-slice/notice-slice";

function CreateNotice() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { type } = useParams();
  const { user } = useAuth();
  const [files, setFiles] = useState([]);
  const item = location.state;
  // console.log(item);
  

  const { createLoading, error, updateLoading } = useSelector(
    (state) => state.onlineOrdering.notice
  );

  const form = useForm({
    resolver: zodResolver(createNoticeSchema),
    mode: "onChange",
    defaultValues: {
      type: "create",
      message: "",
      status: true,
      file_manager_id: undefined,
    },
  });
  const errorMessage = getFirstErrorMessage(form);

  useEffect(() => {
    if (type !== "update") return;
    if (!item) {
      navigate("/onlineordering/settings/notice");
      return;
    }
    form.reset({
      type: "update",
      message: item.message || "",
      // status: item.status || "active",
      file_manager_id: item.file_manager_id || undefined,
    });

    if (item.file_manager_id && item.file_manager_url != null) {
      setFiles([
        {
          file_manager_id: item?.file_manager_id,
          preview: item?.file_manager_url,
        },
      ]);
    }
    dispatch(setItemVariants(item.variants));
  }, [type, item?.id, form]);

  const handleSubmit = async (e, { status, isUpdate = false }) => {
    e.preventDefault();

    const isValid = await form.trigger();
    if (!isValid) return;

    const data = form.getValues();
    const payload = {
      ...data,
      // status: status || data.status,
      client_id: user.client_id,
      restaurant_id: user.restaurant_id,
    };
// console.log(payload);
// return

    try {
      dispatch(clearNoticeMessages());

      let res;
      if (isUpdate) {
        // ✅ Update case
        res = await dispatch(
          updateExistingNotice({ id: item.id, data: payload })
        );
        if (updateExistingNotice.fulfilled.match(res)) {
          toast.success("Notice updated successfully!");
        }
      } else {
        res = await dispatch(createNewNotice(payload));
        if (createNewNotice.fulfilled.match(res)) {
          toast.success("Notice created successfully!");
        }
      }
      if (
        res &&
        (createNewNotice.fulfilled.match(res) ||
          updateExistingNotice.fulfilled.match(res))
      ) {
        form.reset();
        dispatch(clearNoticeMessages());
        navigate("/onlineordering/settings/notice");
      } else if (
        res &&
        (createNewNotice.rejected.match(res) ||
          updateExistingNotice.rejected.match(res))
      ) {
        toast.error(res.payload);
      }
    } catch (err) {
      console.log(err);
      toast.error(err.payload || "Something went wrong");
    }
  };

  const { clientId, restaurantId, directory } = useUploaderConfig("menu");

  const handleUploadComplete = (files) => {
    if (Array.isArray(files) && files.length > 0) {
      const file = files[0];
      form.setValue(
        "file_manager_id",
        file.file_id || file.file_manager_id
      );
    }
  };


  return (
    <Layout2 LeftBar={<LeftBar2 sidebarLinks={onlineOrderingLinks} />}>
      <div className="py-5 container">
        {errorMessage && (
          <div className="text-cred mb-2 text-sm mt-4 flex justify-center items-center text-center">
            {errorMessage}
          </div>
        )}
        <Form {...form}>
          <form>
            <Card className="max-w-screen-md bg-cblack6 mx-auto mt-10 text-cwhite">
              <CardHeader>
                <CardTitle>
                  {form.watch("type") == "update"
                    ? "Update Notice"
                    : "Add New Notice"}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="flex flex-col gap-8">
                  <div className="flex flex-col gap-2.5">
                    <FileUploader
                      className=""
                      files={files}
                      multiple={false}
                      replace={true}
                      clientId={clientId}
                      restaurantId={restaurantId}
                      directory={directory}
                      onFilesChange={(updatedFiles) => setFiles(updatedFiles)}
                      onUploadComplete={handleUploadComplete}
                      label="Image"
                    />
                    {form.formState.errors.file_manager_id && (
                      <p className="text-red-600 text-xs font-light">
                        {form.formState.errors.file_manager_id.message}
                      </p>
                    )}
                  </div>
                  <FormInputField
                    name="message"
                    style="bg-cblack7"
                    placeholder={"Enter message"}
                    form={form}
                    type="textarea"
                    label={"Description"}
                  />
                </div>
                <div className="flex justify-center mt-5 gap-5">
                  <Link to={"/onlineordering/settings/notice"}>
                    <Button className="w-32">Cancel</Button>
                  </Link>
                  <Button
                    isLoading={createLoading || updateLoading}
                    type="submit"
                    onClick={(e) =>
                      handleSubmit(e, {
                        isUpdate: type === "update",
                      })
                    }
                    disabled={createLoading || updateLoading}
                    className="w-32 bg-cgreen text-cwhite"
                  >
                    {type === "update" ? "Update" : "Publish"}
                  </Button>
                </div>
              </CardContent>
            </Card>

          </form>
        </Form>
      </div>
    </Layout2>
  );
}

export default CreateNotice;

export const createNoticeSchema = z.object({
  message: z.string().min(5, "Description is required"),
  file_manager_id: z
    .number({
      required_error: "Please upload an image",
      invalid_type_error: "File ID must be a number",
    })
    .int("File ID must be an integer")
    .optional(),
  // status: z.enum([true, false]).default(true),
});
